import * as React from "react";
import { UitkLayoutGrid, UitkLayoutGridItem, UitkLayoutConditionalGridColumnRow } from "uitk-react-layout-grid";
import { DefaultCard } from "./typings";
import { Card } from "./Card";

export interface RecentlyViewedCardsProps {
  cardsData: DefaultCard[];
}

export const RecentlyViewedCards: React.FunctionComponent<RecentlyViewedCardsProps> = ({ cardsData }) => {
  const MIN_AMOUNT_OF_CARDS = 2;
  const mainGridColumns: UitkLayoutConditionalGridColumnRow =
    cardsData.length === MIN_AMOUNT_OF_CARDS ? { small: 1, medium: 1, large: 2 } : { small: 1, medium: 1, large: 3 };

  return (
    <UitkLayoutGrid columns={mainGridColumns} space="four">
      {cardsData.map((card) => (
        <React.Fragment key={card.id}>
          <UitkLayoutGridItem>
            <Card {...card} />
          </UitkLayoutGridItem>
        </React.Fragment>
      ))}
    </UitkLayoutGrid>
  );
};
